import * as React from "react";
import { formatStatusColour } from "app/utils/filters";

type Props = {
  data: any;
};

class HistoricalRefundRequests extends React.Component<Props> {
  handleRowClick(refund_id) {
    window.location.href = `/snapscan/ops/refund_requests/${refund_id}/summary`;
  }

  render() {
    return (
      <div>
        <table
          style={{
            fontSize: "14px",
            paddingTop: "10px",
            width: "100%",
          }}
          cellPadding={0}
          cellSpacing={0}
          className={`BOTable`}
        >
          <thead>
            <tr>
              <td colSpan={4}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: "10px",
                  }}
                >
                  Historical Refund Requests
                </h3>
              </td>
            </tr>
            <tr>
              <th>
                <b style={{ color: "#555" }}>Refund ID</b>
              </th>
              <th>
                <b style={{ color: "#555" }}>Amount</b>
              </th>
              <th>
                <b style={{ color: "#555" }}>Status</b>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.props.data.map((element) => (
              <tr
                key={element.id}
                onClick={() => this.handleRowClick(element.id)}
                style={{ backgroundColor: formatStatusColour(element.status) }}
              >
                <td>{element.id} </td>
                <td> R{(parseInt(element.amount) / 100).toFixed(2)} </td>
                <td>{element.status} </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default HistoricalRefundRequests;
